import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function collectSidebarSectionHeadingFields(fields: SchemaField[]): SchemaField[] {
  const headingFields: SchemaField[] = []

  for (const field of fields) {
    if (field.type === 'section' && field.slot === 'sidebar' && field.heading?.title) {
      headingFields.push(field)
      continue
    }
    if (field.slot === 'sidebar') continue

    if ((field.type === 'group' || field.type === 'section') && field.fields) {
      headingFields.push(...collectSidebarSectionHeadingFields(field.fields))
    }
    if (field.type === 'tabs' && field.tabs) {
      for (const tab of field.tabs) {
        headingFields.push(...collectSidebarSectionHeadingFields(tab.fields || []))
      }
    }
  }

  return headingFields
}
